import { render, staticRenderFns } from "./Tagger.vue?vue&type=template&id=b2cdee62&scoped=true&"
import script from "./Tagger.vue?vue&type=script&lang=js&"
export * from "./Tagger.vue?vue&type=script&lang=js&"
import style0 from "./Tagger.vue?vue&type=style&index=0&id=b2cdee62&prod&scoped=true&lang=css&"
import style1 from "./Tagger.vue?vue&type=style&index=1&id=b2cdee62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cdee62",
  null
  
)

export default component.exports